import { render, staticRenderFns } from "./Martin_add_dialog.vue?vue&type=template&id=63bdc67b&scoped=true"
import script from "./Martin_add_dialog.vue?vue&type=script&lang=js"
export * from "./Martin_add_dialog.vue?vue&type=script&lang=js"
import style0 from "./Martin_add_dialog.vue?vue&type=style&index=0&id=63bdc67b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e128dc07b65f661f3a32bbc83dd42e36/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bdc67b",
  null
  
)

export default component.exports